import { cva } from 'class-variance-authority';
import WithFeatureFlag from 'components/WithFeatureFlag';
import React from 'react';
import { serialize } from 'utils/commonFunctions';
import { TRACKING_ELEMENT_ID } from 'utils/constants';

const AdBanner = ({ platformType = 'desktop', trackingConstant, ...restProps }) => {
  const { types } = restProps;

  const getEnabledType = Object.entries(types).find(([key, val]) => val.enabled)?.[0] || null;

  const adBannerCVA = cva('si-ad', {
    variants: {
      platformType: {
        desktop: '',
        mobile: 'si-hidden--md'
      }
    }
  });

  switch (getEnabledType) {
    case 'google':
      return (
        <div className='waf-component waf-ad'>
          <div className='waf-ad-wrapper'>
            <div id={platformType === 'desktop' ? 'snack_dex16' : 'snack_mex14'}></div>
          </div>
        </div>
      );
    case 'sponsor':
      return (
        <div
          className={adBannerCVA({ platformType })}
          id={TRACKING_ELEMENT_ID}
          track-event={serialize(trackingConstant)}
        >
          <img src={require('assets/images/ad-banner-web.png')} />
        </div>
      );

    default:
      return null;
  }
};

const AdBannerWithFeatureFlag = WithFeatureFlag(AdBanner);

const FlagSecuredAdBanner = (props) => (
  <AdBannerWithFeatureFlag {...props} feature='advertisement' />
);

export { FlagSecuredAdBanner };
